import { boolean, number, object } from 'yup';

import { messages } from '../../../data/utils/form.utils';

export const schema = object()
  .shape({
    blockMinutes: number()
      .transform(value => (Number.isNaN(value) ? undefined : Number(value)))
      .min(5)
      .max(120)
      .required(),
    fallBackMinutes: number()
      .transform(value => (Number.isNaN(value) ? undefined : Number(value)))
      .min(5)
      .max(120)
      .required(),
    editAppointmentBeforeHours: number()
      .transform(value => (Number.isNaN(value) ? -1 : Number(value)))
      .default(4)
      .test(
        'in-range',
        'common.errors.edit-before-hours',
        value =>
          value === undefined || value === null || (value >= 0 && value < 8766)
      )
      .required(messages.required.id),
    snap: boolean().default(false).nullable(),
  })
  .required()
  .noUnknown();
